import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MenuItem } from '../../../core/models/domain.models';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MenuManagementService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  list() {
    return this.http.get<MenuItem[]>(`${this.baseUrl}/api/menus`, { withCredentials: true });
  }

  create(payload: Partial<MenuItem>) {
    return this.http.post<MenuItem>(`${this.baseUrl}/api/menus`, payload, { withCredentials: true });
  }

  update(id: string, payload: Partial<MenuItem>) {
    return this.http.patch<MenuItem>(`${this.baseUrl}/api/menus/${id}`, payload, { withCredentials: true });
  }

  delete(id: string) {
    return this.http.delete<{ message: string }>(`${this.baseUrl}/api/menus/${id}`, { withCredentials: true });
  }
}
